import { render, staticRenderFns } from "./TrustedPersonInfo.vue?vue&type=template&id=2ada8d39&scoped=true&"
import script from "./TrustedPersonInfo.vue?vue&type=script&lang=js&"
export * from "./TrustedPersonInfo.vue?vue&type=script&lang=js&"
import style0 from "./TrustedPersonInfo.vue?vue&type=style&index=0&id=2ada8d39&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ada8d39",
  null
  
)

export default component.exports